/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const liveSearchProductsButtons = {
    /**
     * Create loading placeholders to reserve product card space.
     *
     * @param {string} direction
     * @param {number} page
     * @returns {Array<{renderKey: string}>}
     */
    createLoadingPlaceholderSlots(direction, page) {
        const pageSize = Number(this.pagesSize) || 0
        if (pageSize <= 0) {
            return []
        }

        let count = pageSize
        const totalProducts = Number(this.productsTotal)
        if (Number.isFinite(totalProducts) && totalProducts > 0) {
            count = Math.max(Math.min(totalProducts - this.products.length, pageSize), 0)
        }

        const keyPrefix = `loading-${direction}-${page}-${Date.now()}`
        return Array.from({ length: count }, (_, index) => ({
            renderKey: `${keyPrefix}-${index}`
        }))
    },
    /**
     * Show previous load button
     *
     * @returns {boolean}
     */
    showPreviousLoadButton() {
        return !this.productsLoading &&
            this.products.length > 0 &&
            !this.pagesLoaded.includes(1)
    },
    /**
     * Callback for previous load button
     */
    callbackPreviousLoadButton() {
        if (this.productsLoading) {
            return
        }

        const lowestPage = Math.min(...this.pagesLoaded)
        this.getProducts('previous', lowestPage - 1)
    },
    /**
     * Show next load button
     *
     * @returns {boolean}
     */
    showNextLoadButton() {
        const totalPages = Number(this.pagesTotal)
        return Number.isFinite(totalPages) &&
            totalPages > 0 &&
            this.products.length > 0 &&
            !this.pagesLoaded.includes(totalPages)
    },
    /**
     * Callback for next load button
     */
    callbackNextLoadButton() {
        if (this.productsLoading) {
            return
        }

        const highestPage = Math.max(...this.pagesLoaded)
        const nextPage = highestPage + 1

        if (this.loadingPlaceholderTimeoutId) {
            window.clearTimeout(this.loadingPlaceholderTimeoutId)
            this.loadingPlaceholderTimeoutId = null
        }

        this.loadingPlaceholderTimeoutId = window.setTimeout(() => {
            this.loadingPlaceholderTimeoutId = null

            if (!this.productsLoading) {
                return
            }

            this.loadingPlaceholderSlots = this.createLoadingPlaceholderSlots('next', nextPage)
        }, 180)

        this.getProducts('next', nextPage)
    }
}

export default liveSearchProductsButtons
